import {
  inject,
  Injectable,
} from '@angular/core';
import {Observable} from 'rxjs';
import {ApolloLink} from '@apollo/client';
import {ApiGraphqlService} from '../../core/api-graphql/api-graphql.service';
import {GET_MY_DEPUTIES} from '../queries/deputy.query.model';
import {AnyObject} from '../../../../../models/object.model';

@Injectable({
  providedIn: 'root',
})
export class ApiDeputyService {

  private apiGraphqlService: ApiGraphqlService = inject(ApiGraphqlService);

  /**
   * Method API: Get the list of colleagues the current user is a deputy of.
   * @returns An Observable that emits the result of the query.
   */
  public getMyDeputiesObservable(): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.query(GET_MY_DEPUTIES);
  }

}
